import "./RaikoCustomAparatInput.scss"
import {useEffect, useState} from "react";
import RaikoMaterialOutlinedInput from "../raikoInputs/RaikoMaterialOutlinedInput";
import RaikoGridOneColumn from "../raikoCustomGrids/RaikoGridOneColumn";
import {css} from "@emotion/css";
import {LoadingHelper} from "../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import ButtonSecondaryRaiko from "../raikoButtons/ButtonSecondaryRaiko";
import RaikoDefaultDialogPage, {DialogSize} from "../../component/defaultDialogPage/RaikoDefaultDialogPage";
import img1 from "./images/aparat.help-3.png";
import img2 from "./images/aparat-help-4.png";
import {SnackbarHelper} from "../../util/SnackbarHelper";
import {useSnackbarDispatcher} from "../../context/SnackBarContext";

export default function (
    {
        link = "https://www.aparat.com/video/video/embed/videohash/lxIF5/vt/frame",
        changeLink
    }) {

    useEffect(() => {
        if (typeof link !== 'undefined' && link.length > 0 && link.search("https://") >= 0) {
            setAparatLink(link)
        }
    }, [link])


    const [aparatLink, setAparatLink] = useState("");

    const loading = new LoadingHelper(useLoadingDispatcher())
    const snackbar = new SnackbarHelper(useSnackbarDispatcher())

    function getSrcFromLink(value) {
        loading.show()

        let iframeValue = ""

        value.split(" ").map((item, index) => {
            if (item.search('src=') >= 0)
                iframeValue = item.replace(`src=`, "").replaceAll('"', '')
        })

        setAparatLink(iframeValue)
        changeLink(iframeValue)

        if (iframeValue.length === 0 && value.length > 0) {
            snackbar.showWarningMessage("کد آی فریم وارد شده صحیح نمی باشد!")
        }

        loading.hide()
    }

    const [openHelpDialogState, setOpenHelpDialogState] = useState(false);

    function handleOpenDialog() {
        setOpenHelpDialogState(true)
    }

    function handleCloseDialog() {
        setOpenHelpDialogState(false)
    }

    return (
        <>
            <RaikoDefaultDialogPage
                onClose={handleCloseDialog}
                open={openHelpDialogState}
                pageTitle={"راهنما"}
                dialogSize={DialogSize.MEDIUM}>

                <RaikoGridOneColumn className={"aparatHelpContainer"}>
                    <span>ابتدا به صفحه ی ویدیو به اشتراک گذاشته شده در آپارات بروید.</span>
                    <span>در جزئیات ویدیو ی انتخابی بعد از کلیک بر روی سه نقطه گزینه ی <strong
                        className={css`color: var(--color-primary)`}>دریافت کد امبد</strong> را انتخاب نمایید.</span>
                    <img src={img1} alt=""/>
                    <span>در قسمت بالای دیالوگ باز شده گزینه ی <strong className={css`color: var(--color-primary)`}>کد آی فریم</strong> را انتخاب کرده و مقدار درج شده در کادر را کپی نمایید.</span>
                    <span>با مراجعه به پنل رایکو با راست کلیک بر روی کادر مشخص شده و انتخاب گزینه ی paste و یا انتخاب کادر مشخص شده و زدن کلیک های ترکیبی ctrl+v می تواندی کد آی فریم کپی شده را درج نمایید.</span>
                    <img src={img2} alt=""/>

                </RaikoGridOneColumn>
            </RaikoDefaultDialogPage>
            <section className={"baseAparatContainer"}>
                {aparatLink && aparatLink.length > 0 &&
                    <section className={"aparatIframeContainer"}>
                        <iframe
                            loading='eager'
                            title={"title"}
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture full"
                            src={aparatLink}
                            allowFullScreen="true"/>
                    </section>
                }
                <RaikoGridOneColumn className={css`margin-top: 1rem`}>
                    <div
                        className={css`
                          display: flex;
                          flex-wrap: nowrap;
                          gap: .5rem`}>
                        <RaikoMaterialOutlinedInput
                            value={aparatLink}
                            onChange={event => {
                                getSrcFromLink(event.target.value)
                            }}
                            placeHolder={"لطفا کد آی فریم ویدیو مورد نظر خود را paste نمایید."}
                        />
                        <ButtonSecondaryRaiko label={"راهنما"} onClick={handleOpenDialog}/>
                    </div>
                </RaikoGridOneColumn>


            </section>
        </>
    )
}